import { SerialNumberDto } from "../../state/serial-number/SerialNumber"

export const hasHistoryWithRowID = (referenceRowId, serialNumbers: SerialNumberDto[]) => {
    if (serialNumbers === null || serialNumbers.length === 0 || referenceRowId === "") {
        return false
    }
    const referenceFound = serialNumbers.some(serialNumber =>
        serialNumber.attributes.salesHistory?.some(sale => sale.attributes.rowId === referenceRowId)
    )
    return referenceFound
}


// WEBPACK FOOTER //
// ./src/utils/serial-numbers/utils.tsx